import { create, v } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/widgets/middleware/theme';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import dimensions from '@dojo/framework/core/middleware/dimensions';
import { Keys } from '@holmescorp/common';
import { isVariantTitle } from '../utils';
import css from '../css/accordion2.m.css';
const icache = createICacheMiddleware();
const factory = create({ icache, dimensions, theme })
    .properties()
    .children();
export const AccordionPane = factory(({ middleware: { icache, dimensions, theme }, properties, children, id }) => {
    const { key, headingLevel, role, initialOpen = false, onOpen, onClose, useContainer } = properties();
    let { open } = properties();
    let { title, content } = children()[0] || {};
    if (isVariantTitle(title)) {
        title = open ? title.open : title.closed;
    }
    if (!Array.isArray(title)) {
        title = [title];
    }
    if (!Array.isArray(content)) {
        content = [content];
    }
    const themeCss = theme.classes(css);
    if (open === undefined) {
        open = icache.get('open');
        const existingInitialOpen = icache.get('initialOpen');
        if (initialOpen !== existingInitialOpen) {
            icache.set('open', initialOpen);
            icache.set('initialOpen', initialOpen);
            open = initialOpen;
        }
    }
    const controls = `${id}-content`;
    const expanded = open ? 'true' : 'false';
    const level = headingLevel ? `${headingLevel}` : null;
    const hidden = open ? null : 'true';
    const labelledby = `${id}-title`;
    const pane = [
        v('div', {
            key: `${key}-head`,
            id: `${id}-title`,
            ...formatAriaProperties({ controls, expanded }),
            role: role === 'tablist' ? 'tab' : 'button',
            tabIndex: 0,
            classes: [themeCss.heading, 'accordion-tab', open ? 'accordion-tab-selected' : ''],
            onclick: (event) => {
                event.stopPropagation();
                icache.set('open', !open);
                if (open) {
                    onClose && onClose();
                }
                else {
                    onOpen && onOpen();
                }
            },
            onkeydown: (event) => {
                switch (event.key) {
                    case Keys.Enter:
                    case Keys.Space:
                    case Keys.Spacebar:
                        event.preventDefault();
                        icache.set('open', !open);
                        if (open) {
                            onClose && onClose();
                        }
                        else {
                            onOpen && onOpen();
                        }
                }
            }
        }, title),
        open
            ? v('section', {
                id: `${id}-content`,
                ...formatAriaProperties({ labelledby }),
                enterAnimation: themeCss.enter,
                exitAnimation: themeCss.exit,
                classes: [themeCss.body, 'accordion-content'],
                role: role === 'tablist' ? 'tabpanel' : null
            }, content)
            : v('div', {
                ...formatAriaProperties({ hidden, labelledby }),
                id: `${id}-content`,
                key: 'content',
                style: { marginTop: open ? '0px' : `-${dimensions.get('content').offset.height}px` }
            })
    ];
    return useContainer
        ? v('article', { key, role, classes: [themeCss.pane] }, [
            v('div', { role: 'heading', ...formatAriaProperties({ level }), classes: ['accordion-container'] }, pane)
        ])
        : pane;
});
